import { render } from "./Noticia.vue?vue&type=template&id=3834891e&scoped=true"
import script from "./Noticia.vue?vue&type=script&lang=js"
export * from "./Noticia.vue?vue&type=script&lang=js"

import "./Noticia.vue?vue&type=style&index=0&id=3834891e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3834891e"]])

export default __exports__